import { memoize } from 'lodash';
import { snapshot } from 'valtio';
export const createValtioStateGetter = (valtioStore, selector) => {
    return memoize(selector)(snapshot(valtioStore));
};
